import { VUE_APP_MICRO_BASE_URL } from '@pharmsnap/pharmsnap-web/config'
import { useLocale } from '@pharmsnap/shared/composition'
import { sharedCtx } from '@pharmsnap/shared/context'
import { synapseApi2WujieAxiosAdapter, wujieCommonPlugins, wujieInfrastructure } from '@pharmsnap/shared/src/utils/wujie'
import type { LsCommonWechatCodeBindPageWujieProps } from '@synapse-micro-app/micro-ls-common'
import { defineComponent, PropType } from '@vue/composition-api'
import { noop } from 'lodash'
interface IGetCodeResponse {
  /**
   * 传给轮询接口的二维码识别码
   */
  callback_value: string
  /**
   * 二维码过期时间(单位秒)
   */
  expire_seconds?: number
  /**
   * 二维码地址
   */
  pic_url: string
}
export const BWechatBindCodeWujie = defineComponent({
  name: 'BWechatBindCodeWujie',
  props: {
    bindSuccessCallback: {
      type: Function as PropType<() => void>,
      default: noop,
    },
  },
  emits: ['success'],
  setup(props, ctx) {
    const { locale } = useLocale()
    const wujieProps: LsCommonWechatCodeBindPageWujieProps = {
      ctx: {
        locale: locale.value,
      },
      infrastructure: wujieInfrastructure,
      getCodeFn() {
        return sharedCtx.service.login.getWechatBindCode().then(synapseApi2WujieAxiosAdapter)
      },
      pollingScanStatusFn(data) {
        return sharedCtx.service.login.checkWechatBindStatus({ callback_value: data.callback_value }).then(synapseApi2WujieAxiosAdapter)
      },
      successCallback() {
        ctx.emit('success')
      },
    }
    const wuJieEmptyUrl = `${window.location.origin}/wujie/empty.html`
    const wujieAttrs = {
      src: wuJieEmptyUrl,
    }
    const wujieAppName = 'ls-common-wechat-code-bind'
    const wujieUrl = `${VUE_APP_MICRO_BASE_URL}/micro-ls-common#/wechat-code-bind`
    return { wujieAttrs, wujieUrl, wujieProps, wujieAppName }
  },
  render() {
    return (
      <wujie-vue
        class="w-[152px] h-[152px] border border-solid border-gray-200"
        name={this.wujieAppName}
        url={this.wujieUrl}
        plugins={wujieCommonPlugins}
        {...{ props: { attrs: this.wujieAttrs, props: this.wujieProps } }}
      ></wujie-vue>
    )
  },
})
